/** Shared formatting helpers. */

/** Euro, rounded, Italian thousands separators. e.g. fmtEur(8745300) → "€ 8.745.300". */
export function fmtEur(n: number): string {
  return "€ " + Math.round(n).toLocaleString("it-IT");
}

/** Euro to the cent. e.g. fmtEurCents(3841565.84) → "€ 3.841.565,84".
 *
 * Use wherever a figure is being compared against the source document rather
 * than summarised. `fmtEur` rounds, which is right for a dashboard and wrong
 * here: a reconciliation that claims the extraction matches the computo "to the
 * cent" must show the cents, and a residual of € 0,32 must not render as € 0.
 */
export function fmtEurCents(n: number): string {
  return "€ " + n.toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
